// extracted by mini-css-extract-plugin
export default {"home":"c-i_cp","home__background":"c-i_cq","home__content":"c-i_cr"};